<header class="questionnaire">
  <ol>
    <li class="selected"><span>1</span></li>
    <li class="spacer selected"></li>
    <li class="selected"><span>2</span></li>
    <li class="spacer selected"></li>
    <li class="selected">
      <div  >Pytanie</div><span>3</span>
    </li>
  </ol>
</header>
<main class="questionnaire">
  <h2  ><em>3.</em> Jaki efekt dekoracyjny chcesz uzyskać?</h2>
  <ul>
    <li   (click)="onQuestion3Click(EfektDekoracyjny.baranek)"
      [class.selected]="project.ankieta.pytanie3==EfektDekoracyjny.baranek"><img src="assets/photos/baranek.png" /><span>
        <b>Faktura nakrapiana</b><br> powierzchnia o strukturze grudek
        <em>Baranek</em></span>
    </li>
    <li   (click)="onQuestion3Click(EfektDekoracyjny.kornik)"
      [class.selected]="project.ankieta.pytanie3==EfektDekoracyjny.kornik"><img src="assets/photos/kornik.png" />
      <span><b>Faktura kanalikowa</b><br>
        powierzchnia o strukturze rowków
        <em>Kornik</em></span>
    </li>
  </ul>
</main>
<app-footer [prev]="prev" [next]="next"></app-footer>
